import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

export const DataFreshness = () => {
  const { t } = useTranslation();
  return (
    <Alert severity="info" sx={{ mb: 1 }}>
      {t("Data is updated hourly from 8 a.m. to 8 p.m. EST.")}
    </Alert>
  );
};
